import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

const GOOGLE_CLIENT_ID = "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";
const SUPABASE_URL = "https://nlvqfdktrmrtpmobdwfx.supabase.co";
const REDIRECT_URI = `${SUPABASE_URL}/functions/v1/google-auth-callback`;

export const useGoogleCalendarAuth = () => {
  const initiateAuth = (userName: string, googleEmail: string) => {
    try {
      // Build state parameter
      const state = btoa(JSON.stringify({ userName, googleEmail }));
      
      // Build OAuth URL
      const authUrl = new URL('https://accounts.google.com/o/oauth2/v2/auth');
      authUrl.searchParams.set('client_id', GOOGLE_CLIENT_ID);
      authUrl.searchParams.set('redirect_uri', REDIRECT_URI);
      authUrl.searchParams.set('response_type', 'code');
      authUrl.searchParams.set('scope', 'https://www.googleapis.com/auth/calendar.readonly');
      authUrl.searchParams.set('state', state);
      authUrl.searchParams.set('access_type', 'offline');
      authUrl.searchParams.set('prompt', 'consent');

      console.log('Opening OAuth popup:', authUrl.toString());
      
      // Open popup
      const popup = window.open(
        authUrl.toString(),
        'google-auth',
        'width=600,height=700,left=200,top=100'
      );

      if (!popup) {
        toast.error('נא לאפשר חלונות קופצים בדפדפן');
        return;
      }

      // Listen for popup close or success
      const checkPopup = setInterval(() => {
        if (popup.closed) {
          clearInterval(checkPopup);
          // Check URL for success parameter
          const urlParams = new URLSearchParams(window.location.search);
          if (urlParams.get('google_auth') === 'success') {
            toast.success('החיבור ליומן Google בוצע בהצלחה!');
            // Clean URL
            window.history.replaceState({}, '', window.location.pathname);
          }
        }
      }, 500);
    } catch (error) {
      console.error('Error initiating auth:', error);
      toast.error('שגיאה בפתיחת מסך האימות');
    }
  };

  const disconnectCalendar = async (userName: string) => {
    try {
      const { error } = await (supabase as any)
        .from('google_calendar_tokens')
        .delete()
        .eq('user_name', userName);

      if (error) throw error;

      toast.success('החיבור ליומן Google נותק בהצלחה');
      return { success: true };
    } catch (error) {
      console.error('Error disconnecting calendar:', error);
      toast.error('שגיאה בניתוק החיבור');
      return { success: false };
    }
  };

  const checkConnectionStatus = async (userName: string) => {
    try {
      const { data, error } = await (supabase as any)
        .from('google_calendar_tokens')
        .select('google_email, created_at')
        .eq('user_name', userName)
        .maybeSingle();

      if (error) throw error;

      return {
        isConnected: !!data,
        googleEmail: data?.google_email || null,
        connectedAt: data?.created_at || null,
      };
    } catch (error) {
      console.error('Error checking connection status:', error);
      return { isConnected: false, googleEmail: null, connectedAt: null };
    }
  };

  return {
    initiateAuth,
    disconnectCalendar,
    checkConnectionStatus,
  };
};